
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/bf8ff2f5-6575-4657-b53e-bfe71b9d1d2e.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('bf8ff2f5-6575-4657-b53e-bfe71b9d1d2e');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      